import { useLayoutEffect, useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { StringParam, useQueryParam } from 'use-query-params'

import useQuery from '@shared/hooks/src/useQuery'
import { useMe } from '@shared/providers/src/MeProvider'
import { queryClient, setQueryData } from '@shared/providers/src/QueryClientProvider'
import API from '@shared/services/src/API'
import { QK } from '@shared/utils'

export function usePharmacies(userId, options = {}) {
  return useQuery({
    queryKey: QK.users.id(userId).pharmacies.list(),
    queryFn: () => API.users.id(userId).pharmacies.list(),
    ...options,
  })
}

export function usePharmacyUpdate() {
  const me = useMe()

  return useMutation({
    mutationFn: (pharmacyId) => API.users.id(me.id).pharmacies.id(pharmacyId).update(),
    onSuccess: (pharmacy) => {
      // Update the pharmacy and the user's pharmacyId in the cache
      setQueryData(QK.pharmacies.id(pharmacy.id).details, pharmacy)
      setQueryData(QK.me(me.id).details, (prev) => ({ ...prev, pharmacyId: pharmacy.id }))

      setTimeout(() => queryClient.invalidateQueries({ queryKey: undefined }), 0)
    },
  })
}

// Opens the pharmacy selector when the pharmacy query param is present
export function useSelectorState() {
  const [param, setParam] = useQueryParam('pharmacy', StringParam, { updateType: 'replaceIn' })

  const state = useState(false)
  const [, setOpen] = state

  useLayoutEffect(() => {
    if (param) {
      setParam(undefined)
      setOpen(true)
    }
  }, [param, setOpen, setParam])

  return state
}
